import type { StorefrontTagListResponseType } from "@sellar-io/api-v2/types";
import { pluralize } from "@sellar-io/common";
import { Card, ListItemIconTile } from "@sellar-io/components";
import { useSortable } from "@dnd-kit/react/sortable";
import type { ReactElement } from "react";
import { Icon } from "../../../../../components";

export const SortableGroupListItem = ({
  tag,
  index,
  disabled,
  onClick,
}: {
  tag: StorefrontTagListResponseType[number];
  index: number;
  disabled: boolean;
  onClick: () => void;
}): ReactElement => {
  const { ref, handleRef, isDragging } = useSortable({ id: tag.id, index });
  const productCount = tag.ProductStorefrontTag.length;

  return (
    <div
      ref={ref}
      className={isDragging ? "relative z-50 opacity-50" : "relative"}
    >
      <Card className="flex min-w-0 items-center gap-4 border border-zinc-200 bg-white p-4 hover:bg-zinc-50">
        <button
          ref={handleRef}
          type="button"
          disabled={disabled}
          className={`flex shrink-0 items-center rounded-sm focus-visible:outline-2 focus-visible:outline-offset-2 ${disabled ? "cursor-wait opacity-50" : "cursor-grab"}`}
          aria-label={`Reorder ${tag.value}`}
        >
          <Icon icon="MENU" />
        </button>
        <ListItemIconTile icon="VIEW_DASHBOARD_OUTLINE" />
        <button
          type="button"
          onClick={onClick}
          className="flex min-w-0 flex-1 items-center gap-3 rounded-sm text-left focus-visible:outline-2 focus-visible:outline-offset-2"
          aria-label={`Open ${tag.value}, ${productCount} ${pluralize("product", productCount)}`}
        >
          <span className="flex min-w-0 flex-1 flex-col overflow-hidden">
            <span className="truncate font-semibold">{tag.value}</span>
            <span className="text-sm text-zinc-700">
              {productCount} {pluralize("product", productCount)}
            </span>
          </span>
          <span className="text-sm">Edit</span>
          <Icon icon="CHEVRON_RIGHT" />
        </button>
      </Card>
    </div>
  );
};
